import React from 'react'
import styles from './FormSubmitHack.scss'

// forms require an invisible submit button to allow submission based on
// the return key
export const FormSubmitHack = () => (
  <input type='submit' className={styles.FormSubmitHack} />
)
